<template>
    <h2>Web Hosting</h2>
</template>

<script>
    export default {
        name: "HostingComponent"
    }
</script>

<style scoped>

</style>